__turbopack_context__.v({
  "className": "kodemonobold_8fc3c1b1-module__pDchvG__className",
  "variable": "kodemonobold_8fc3c1b1-module__pDchvG__variable",
});
